import { render, staticRenderFns } from "./LogEventosMID.vue?vue&type=template&id=79b5bfeb&"
import script from "./LogEventosMID.vue?vue&type=script&lang=ts&"
export * from "./LogEventosMID.vue?vue&type=script&lang=ts&"
import style0 from "./LogEventosMID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79b5bfeb', component.options)
    } else {
      api.reload('79b5bfeb', component.options)
    }
    module.hot.accept("./LogEventosMID.vue?vue&type=template&id=79b5bfeb&", function () {
      api.rerender('79b5bfeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MID/LogEventosMID.vue"
export default component.exports